export default __webpack_public_path__ + "static/media/q9_step1_4.8576157f.png";